import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiteMapStore } from '../../site-map.store';
import { HOLE_FEATURES, HOLE_STATUSES, holeFeatureIcon, holeStatusIcon } from '../../utils/hole-appearance';

@Component({
  selector: 'app-site-map-holes-panel',
  standalone: true,
  templateUrl: './holes-panel.component.html',
  styleUrls: ['./holes-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SiteMapHolesPanelComponent {
  protected readonly store = inject(SiteMapStore);
  protected readonly statuses = HOLE_STATUSES;
  protected readonly features = HOLE_FEATURES.map(feature => ({
    feature,
    icon: holeFeatureIcon(feature),
    label: feature.charAt(0).toUpperCase() + feature.slice(1),
  }));
  protected readonly statusIcon = holeStatusIcon;
}
